/**
 * Does as advertised! Just pass a script Src.
 * @param src string
 */
export const addScriptTagToHead = (src: string) => {
  const head = document.getElementsByTagName('head')?.item(0);
  const scriptTagToAppend = document.createElement('script');
  scriptTagToAppend.src = src;

  if (!head || !src) {
    console.error('Failed to load script tag. Head element was either not found or src parameter was undefined!');
    return;
  }

  head.appendChild(scriptTagToAppend);
};
